/*  Shared  */
import { LastUpdatedCard } from 'application/Shared/Components/Cards/Components/LastUpdatedCard';
import { Route } from 'application/Shared/Helpers';
import { formatDistanceToNow } from 'application/Shared/Helpers/Dates';

/* Hooks */
import { useFetchCalculation } from 'hooks/dataAccess/Calculation/calculation';

/*  React  */
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const UserActiveAppsCard = () => {
    const { t } = useTranslation();
    const { clientId, userId, partnerId } = useParams();
    const params = useMemo(() => ({ linkedId: userId }), [userId]);
    const { calculations, calculationDates } = useFetchCalculation({
        clientId,
        params
    });
    const route = Route.buildBaseAdminRoute({ clientId, partnerId });

    return (
        <LastUpdatedCard
            content={
                calculations?.user_weekly_app_count
                    ? calculations.user_weekly_app_count
                    : '-'
            }
            buttonText={t('UserDashboard.view_applications')}
            lastUpdated={
                <Trans
                    i18nKey="UserDashboard.last_calculated"
                    components={{
                        Date: calculationDates?.user_weekly_app_count ? (
                            <>
                                {formatDistanceToNow(
                                    calculationDates.user_weekly_app_count
                                )}
                            </>
                        ) : (
                            <>{t('Common.never')}</>
                        )
                    }}
                />
            }
            route={`${route}/user/${userId}/admin`}
            title={t('UserDashboard.last_week_active_applications')}
        />
    );
};
